var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{style:(("border: 4px solid " + _vm.colorByStatus + "; border-radius: 8px")),attrs:{"flat":""}},[_c('v-card-text',[_c('div',[_vm._v(_vm._s(_vm.titleText))]),_vm._v(" "),_c('h3',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.quantity))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38dae37a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/tcp/Broadcast/BroadcastTotalQtyByStatusCard.vue
// module id = null
// module chunks = 